export interface WmoInfo {
  emoji: string;
  label: string;
}

interface WmoEntry {
  emoji: string;
  labels: Record<string, string>;
}

const WMO_MAP: Record<number, WmoEntry> = {
  0:  { emoji: '☀️',  labels: { 'zh-TW': '晴天',   'zh-CN': '晴天',   en: 'Sunny' } },
  1:  { emoji: '🌤️', labels: { 'zh-TW': '大致晴朗', 'zh-CN': '大致晴朗', en: 'Mostly Clear' } },
  2:  { emoji: '⛅',  labels: { 'zh-TW': '局部多雲', 'zh-CN': '局部多云', en: 'Partly Cloudy' } },
  3:  { emoji: '☁️',  labels: { 'zh-TW': '陰天',   'zh-CN': '阴天',   en: 'Overcast' } },
  45: { emoji: '🌫️', labels: { 'zh-TW': '霧',     'zh-CN': '雾',     en: 'Fog' } },
  48: { emoji: '🌫️', labels: { 'zh-TW': '霧',     'zh-CN': '雾',     en: 'Fog' } },
  51: { emoji: '🌦️', labels: { 'zh-TW': '毛毛雨',  'zh-CN': '毛毛雨',  en: 'Light Drizzle' } },
  53: { emoji: '🌦️', labels: { 'zh-TW': '毛毛雨',  'zh-CN': '毛毛雨',  en: 'Drizzle' } },
  55: { emoji: '🌦️', labels: { 'zh-TW': '毛毛雨',  'zh-CN': '毛毛雨',  en: 'Heavy Drizzle' } },
  61: { emoji: '🌧️', labels: { 'zh-TW': '小雨',   'zh-CN': '小雨',   en: 'Light Rain' } },
  63: { emoji: '🌧️', labels: { 'zh-TW': '中雨',   'zh-CN': '中雨',   en: 'Moderate Rain' } },
  65: { emoji: '🌧️', labels: { 'zh-TW': '大雨',   'zh-CN': '大雨',   en: 'Heavy Rain' } },
  71: { emoji: '🌨️', labels: { 'zh-TW': '小雪',   'zh-CN': '小雪',   en: 'Light Snow' } },
  73: { emoji: '🌨️', labels: { 'zh-TW': '中雪',   'zh-CN': '中雪',   en: 'Moderate Snow' } },
  75: { emoji: '🌨️', labels: { 'zh-TW': '大雪',   'zh-CN': '大雪',   en: 'Heavy Snow' } },
  80: { emoji: '🌦️', labels: { 'zh-TW': '陣雨',   'zh-CN': '阵雨',   en: 'Showers' } },
  81: { emoji: '🌦️', labels: { 'zh-TW': '陣雨',   'zh-CN': '阵雨',   en: 'Showers' } },
  82: { emoji: '🌦️', labels: { 'zh-TW': '強陣雨',  'zh-CN': '强阵雨',  en: 'Heavy Showers' } },
  95: { emoji: '⛈️',  labels: { 'zh-TW': '雷雨',   'zh-CN': '雷雨',   en: 'Thunderstorm' } },
  96: { emoji: '⛈️',  labels: { 'zh-TW': '強雷雨',  'zh-CN': '强雷雨',  en: 'Heavy Thunderstorm' } },
  99: { emoji: '⛈️',  labels: { 'zh-TW': '強雷雨',  'zh-CN': '强雷雨',  en: 'Heavy Thunderstorm' } },
};

export function getWmoInfo(code: number, lang = 'zh-TW'): WmoInfo {
  const entry = WMO_MAP[code];
  if (!entry) return { emoji: '🌡️', label: lang === 'en' ? 'Unknown' : '未知' };
  return {
    emoji: entry.emoji,
    label: entry.labels[lang] ?? entry.labels['zh-TW'],
  };
}
